(function(){
  
  const NAV_TOGGLE = document.querySelector('.nav-toggle');
  const DASH_NAV_TOGGLE = document.getElementById('rw-dash-nav-toggle');
  const IS_DASHBOARD = document.querySelector('body').classList.contains('layout-investor-dashboard');
  const BODY = document.querySelector('body');
  
  if(!NAV_TOGGLE) return false;
  
  
  const NAV_DRAWER = document.querySelector('.main-header__nav-drawer');
  // const RESOURCES_BAR_NAV_DRAWER = document.querySelector('.main-header__resources-bar__nav-drawer');
  const DASH_NAV_DRAWER = document.querySelector('.rw-dash-nav');
  
  NAV_TOGGLE.addEventListener('click', (evt) => {
    evt.preventDefault();
    console.log('nav toggle clicked');
    NAV_DRAWER.classList.toggle('shown');
    // RESOURCES_BAR_NAV_DRAWER.classList.toggle('shown');
    NAV_TOGGLE.classList.toggle('nav-toggle--active');
    if(DASH_NAV_DRAWER){
      DASH_NAV_TOGGLE.classList.remove('rw-dash-nav__toggle--active');
      DASH_NAV_DRAWER.classList.remove('rw-dash-nav--nav-active');
    }
  });

  if(window.outerWidth <= 1024){
    // $('.primary-nav__dropdown, .nav-drawer').addClass('collapse');
    $(document).ready(function(){
      $('.primary-nav__dropdown, .nav-drawer').on('hide.bs.collapse', function (evt) {
        let target = document.querySelector('[href="#' + evt.target.id +  '"]');
        target.classList.remove('shown');
        target.parentNode.classList.remove('shown');
      });

      $('.primary-nav__dropdown, .nav-drawer').on('show.bs.collapse', function (evt) {
        let target = document.querySelector('[href="#' + evt.target.id +  '"]');
        target.classList.add('shown');
        target.parentNode.classList.add('shown');
      });
    });
  }

    
}());